export const isInIframe = () => {
  if (window.location !== window.parent.location) {
    return true;
  }
  return false;
};
